import Lecture from './ScheduleLecture'
import LectureList from './LectureList'
const exportObj = {
    Lecture,
    LectureList,
}

export default exportObj